// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"0b99bdbc","787":"e00cf648"}[chunkId] + ".chunk.js";
};